import { prop, sort as sortBy, ascend, descend } from 'ramda';
import { createSelector } from 'reselect';
import S from 'common/service/sanctuary';

import {
  collection,
  selection,
} from 'common/store/selectors';
import { SORT_ASC, SORT_DESC } from 'common/store/collection/reducer';

const getScope = ({ job: { jobs } }) => jobs;

const collectionSelectors = collection.factory(getScope);
const selectionSelectors = selection.factory(getScope);
 
export const {
  isSorted, 
  getPaginator,
  getTotal,
  isLoading, 
  getQuery,
  getSearch,
  getStoreParams,
  getSorter,
  localSearch,
} = collectionSelectors;

export const {
  isSelected,
  getSelected,
} = selectionSelectors;

export const getJobsContext = collectionSelectors.getCollectionContext;
export const getJobsMaybe = collectionSelectors.getCollectionMaybe;

export const getJobsSorter = createSelector(
  getStoreParams,
  ({ sort }) => sortBy({
    [SORT_ASC]: ascend,
    [SORT_DESC]: descend,
  }[sort.direction](S.prop(sort.property))),
);

export const getJobsFilter = createSelector(
  getJobsSorter,
  localSearch,
  (sortJobs, search) => S.pipe([search, sortJobs]),
);

